import * as actionTypes from "../../../actions/actionTypes";
import { updateObject } from "../../../utility";

const initialState = {
  allProjects: null,
  projectsLoading: null,
  milestones: null,
  count: null,
  projectId: null,
  totalOfDone: null,
  pageS: 4,
  percentage: 0,
  loading: null,
  error: null,
};

//select projectId

const selectProjectId = (state, action) => {
  return updateObject(state, { projectId: action.projectId });
};
const clearProjectId = (state, action) => {
  return updateObject(state, { projectId: null, milestones: null });
};

// fetch all projects for milestone
const fetchClientProjectStart = (state, action) => {
  return updateObject(state, { error: null, projectsLoading: true });
};

const fetchClientProjectSuccess = (state, action) => {
  return updateObject(state, {
    allProjects: action.projects,
    error: null,
    projectsLoading: false,
  });
};

const fetchClientProjectFail = (state, action) => {
  return updateObject(state, {
    error: action.error,
    projectsLoading: false,
  });
};

// Milestone Precent
const MilestonePrecent = (state, action) => {
  return updateObject(state, {
    percentage: action.calc,
  });
};

// fetch milestone
const fetchProjectMilestonesStart = (state, action) => {
  return updateObject(state, { error: null, loading: true });
};

const fetchProjectMilestonesSuccess = (state, action) => {
  return updateObject(state, {
    milestones: action.milestones,
    count: action.count,
    totalOfDone: action.totalOfDone,
    percentage: action.percentage ? action.percentage : 0,
    error: null,
    loading: false,
  });
};

const fetchProjectMilestonesFail = (state, action) => {
  return updateObject(state, {
    error: action.error,
    loading: false,
  });
};

const createProjectMilestoneStart = (state, action) => {
  return updateObject(state, { error: null, loading: true });
};

const createProjectMilestoneSuccess = (state, action) => {
  let newArr = null;
  if (state.pageS === state.milestones.length) {
    let oldArr = [...state.milestones];
    oldArr.pop();
    oldArr.unshift(action.newMilestone);
    newArr = [...oldArr];
  } else {
    let oldArr = [...state.milestones];
    oldArr.unshift(action.newMilestone);
    newArr = [...oldArr];
  }

  return updateObject(state, {
    milestones: newArr,
    msg: action.msg,
    count: state.count + 1,
    error: null,
    loading: false,
  });
};

const createProjectMilestoneFail = (state, action) => {
  return updateObject(state, {
    error: action.error,
    loading: false,
    projectsLoading: false,
  });
};

// update status milestone
const updateStatusMilestoneStart = (state, action) => {
  return updateObject(state, { error: null, loading: true });
};

const updateStatusMilestoneSuccess = (state, action) => {
  let newArr = [...state.milestones].map((arr) => {
    if (arr._id === action.milestoneId) {
      arr.done = action.status;
    }
    return arr;
  });

  return updateObject(state, {
    milestones: newArr,
    totalOfDone:
      action.status === true ? state.totalOfDone + 1 : state.totalOfDone - 1,
    msg: action.msg,
    error: null,
    loading: false,
  });
};

const updateStatusMilestoneFail = (state, action) => {
  return updateObject(state, {
    error: action.error,
    loading: false,
  });
};

// delte milestone
const deleteProjectMilestoneStart = (state, action) => {
  return updateObject(state, { error: null, loading: true });
};

const deleteProjectMilestoneSuccess = (state, action) => {
  const updatedArray = state.milestones.filter(
    (milestone) => milestone._id !== action.milestoneId
  );
  // console.log(updatedArray);
  return updateObject(state, {
    milestones: updatedArray,
    error: null,
    loading: false,
  });
};

const deleteProjectMilestoneFail = (state, action) => {
  return updateObject(state, {
    error: action.error,
    loading: false,
  });
};

const clearMsgProjectMilestone = (state, action) => {
  return updateObject(state, {
    error: null,
    loading: false,
    msg: null,
  });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_CLIENT_PROJECTS_FOR_MILESTONE_START:
      return fetchClientProjectStart(state, action);
    case actionTypes.FETCH_CLIENT_PROJECTS_FOR_MILESTONE_SUCCESS:
      return fetchClientProjectSuccess(state, action);
    case actionTypes.FETCH_CLIENT_PROJECTS_FOR_MILESTONE_FAIL:
      return fetchClientProjectFail(state, action);

    case actionTypes.MILESTONE_PERCENT:
      return MilestonePrecent(state, action);

    case actionTypes.FETCH_PROJECT_MILESTONES_START:
      return fetchProjectMilestonesStart(state, action);
    case actionTypes.FETCH_PROJECT_MILESTONES_SUCCESS:
      return fetchProjectMilestonesSuccess(state, action);
    case actionTypes.FETCH_PROJECT_MILESTONES_FAIL:
      return fetchProjectMilestonesFail(state, action);

    case actionTypes.CREATE_PROJECT_MILESTONE_START:
      return createProjectMilestoneStart(state, action);
    case actionTypes.CREATE_PROJECT_MILESTONE_SUCCESS:
      return createProjectMilestoneSuccess(state, action);
    case actionTypes.CREATE_PROJECT_MILESTONE_FAIL:
      return createProjectMilestoneFail(state, action);

    case actionTypes.UPDATE_STATUS_PROJECT_MILESTONE_START:
      return updateStatusMilestoneStart(state, action);
    case actionTypes.UPDATE_STATUS_PROJECT_MILESTONE_SUCCESS:
      return updateStatusMilestoneSuccess(state, action);
    case actionTypes.UPDATE_STATUS_PROJECT_MILESTONE_FAIL:
      return updateStatusMilestoneFail(state, action);

    case actionTypes.DELETE_PROJECT_MILESTONE_START:
      return deleteProjectMilestoneStart(state, action);
    case actionTypes.DELETE_PROJECT_MILESTONE_SUCCESS:
      return deleteProjectMilestoneSuccess(state, action);
    case actionTypes.DELETE_PROJECT_MILESTONE_FAIL:
      return deleteProjectMilestoneFail(state, action);

    case actionTypes.CLEAR_MSG_PROJECT_MILESTONE:
      return clearMsgProjectMilestone(state, action);
    case actionTypes.SELECT_PROJECT_ID:
      return selectProjectId(state, action);
    case actionTypes.CLEAR_PROJECT_ID:
      return clearProjectId(state, action);
    // case actionTypes.SELECT_PROJECT_MILESTONES:
    //   return selectProjectMilestones(state, action)
    default:
      return state;
  }
};

export default reducer;
